'use client'
import type { FormHelperTextProps } from '@mui/material/FormHelperText'

import FormHelperText from '@mui/material/FormHelperText'

import { styled } from '@mui/material/styles'

type InputHelperTextProps = FormHelperTextProps

const InputHelperText = styled(FormHelperText)<InputHelperTextProps>(({ theme, error }) => ({
  '&.MuiFormHelperText-root': {
    color: theme.colors.text.tertiary,
    /* Inputs/helper-text */
    fontFamily: theme.fonts.family.body,
    fontSize: theme.fonts.size.xs,
    fontStyle: 'normal',
    fontWeight: theme.fonts.weight.normal,
    lineHeight: theme.fonts.lineHeight['leading-4'],
    letterSpacing: theme.fonts.letterSpacing.wide,
  },
  '&.Mui-error': {
    color: theme.colors.text.error,
  },
  '&.Mui-focused': {
    color: error
      ? theme.colors.text.error
      : theme.colors.text.primary,
  },
}))

export default InputHelperText
export type { InputHelperTextProps }
